import dayjs from "dayjs";
import { toLocalGraphTime } from "../../../../utils/date";

// Shared constants for ripening graph styling
// Shared time axis so all ripening graphs read like the room sensor graph (Plotly picks the ticks), hover time as HH:mm.
export const RIPENING_GRAPH_XAXIS = {
    title: "Time",
    fixedrange: true,
    showgrid: false,
    showline: true,
    automargin: true,
    hoverformat: "%b %d, %Y %H:%M",
};

const MIN_XAXIS_SPAN_MS = 60 * 60 * 1000;

// Checks taken minutes apart would make Plotly tick in seconds; keep at least an hour in view so ticks stay HH:mm.
export function ripeningGraphXAxis(traces: { x?: unknown[] }[]) {
    const times = traces.flatMap((trace) => trace.x ?? []).map((x) => dayjs(x as string).valueOf()).filter(Number.isFinite);
    if (!times.length) {
        return RIPENING_GRAPH_XAXIS;
    }
    const min = Math.min(...times);
    const max = Math.max(...times);
    if (max - min >= MIN_XAXIS_SPAN_MS) {
        return RIPENING_GRAPH_XAXIS;
    }
    const middle = (min + max) / 2;
    return {
        ...RIPENING_GRAPH_XAXIS,
        range: [toLocalGraphTime(middle - MIN_XAXIS_SPAN_MS / 2), toLocalGraphTime(middle + MIN_XAXIS_SPAN_MS / 2)],
    };
}

export const RIPENING_GRAPH_STYLES = {
    colors: {
        actualLine: "#212529",
        predictedLine: "#343a40",
        actualBand: "rgba(0, 0, 0, 0.1)",
        predictedBand: "rgba(0, 0, 0, 0.1)",
        fill: "rgba(0, 0, 0, 0.1)",
    },
    marker: {
        // Marker colors for GroupRipeningGraph
        actualLine: "black",
        predictedLine: "#656565",
        actualUpper: "black",
        predictedUpper: "#656565",
        actualLower: "black",
        predictedLower: "#656565",
        // Marker sizes
        size: 12,
        upperLowerSize: 10, // For upper/lower bound markers in GroupRipeningGraph
    },
    // Band opacity - match backend
    bandOpacity: 0.7, // Match backend: opacity=0.7 for confidence band
    // Category/swimming lane opacity - match backend
    categoryOpacity: 0.2, // Match backend: opacity=0.2 for ripeness intervals
    // Line widths - match backend
    lineWidth: {
        actual: 3, // Actual line width
        predicted: 5, // Match backend: width=5 for predictions
        trend: 3, // Trend line width for GroupRipeningGraph
    },
} as const;

